import {
  GET_LELOENTRIES,
  GET_LELOENTRIE,
  UPDATE_LELOENTRIE,
  FILTER_TABLE,
  CLEAR_FILTER_TABLE,
  SEARCH_FILTER,
  CLEAR_SEARCH_FILTER,
  CLEAR_LELOENTRIE,
  CLEAR_INACTIVE_FILTER,
  INACTIVE_FILTER,
  SESSION_FILTER,
  CLEAR_SESSION_FILTER,
  ACTIVE_FILTER,
  SIGNED_FILTER,
  FILTER_BY_DATE,
  CLEAR_DATE_FILTER,
  GET_LELO_SESSION,
  SET_LOADING,
  ON_FORM_DATA_CHANGE,
  GET_LELOENTRIES_OPTIMIZED,
  SET_LOADING_OPTIMIZED,
  GET_LELOENTRIES_OPTIMIZED_ZIP,
  SET_LIST_VIEW,
} from "../types";

const adminLeloReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    // case GET_LELOENTRIES:
    //   const newEntries = Array.isArray(payload) ? payload : [];

    //   return {
    //     ...state,
    //     Leloentries: newEntries,
    //     filteredEntries: newEntries,
    //     SessionEntries: newEntries,
    //     InactiveFiltered: newEntries.filter((item) => item.status === "Inactive"),
    //     ActiveFiltered: newEntries.filter((item) => item.status === "Active"),
    //     SignedFiltered: newEntries.filter((item) => item.status === "Signed"),
    //     LeloListStatus: {
    //       inactive: false,
    //       active: true,
    //       signed: false,
    //     },
    //   };
    //   // return {
    //   //   ...state,
    //   //   Leloentries: payload,
    //   //   filteredEntries: payload,
    //   //   SessionEntries: payload,
    //   //   InactiveFiltered: payload.filter((item) => item.status === "Inactive"),
    //   //   ActiveFiltered: payload.filter((item) => item.status === "Active"),
    //   //   SignedFiltered: payload.filter((item) => item.status === "Signed"),
    //   //   LeloListStatus: {
    //   //     inactive: false,
    //   //     active: true, // Default to "Active"
    //   //     signed: false,
    //   //   },
    //   // };
    case GET_LELOENTRIES:
      const status = action.status || "Active";
      return {
        ...state,
        Leloentries: payload,
        filteredEntries: payload,
        SessionEntries: payload,
        appliedFilters: action.appliedFilters,
        InactiveFiltered: payload.filter((item) => item.status === "Inactive"),
        ActiveFiltered: payload.filter((item) => item.status === "Active"),
        SignedFiltered: payload.filter((item) => item.status === "Signed"),
        LeloListStatus: {
          inactive: status === "Inactive",
          active: status === "Active",
          signed: status === "Signed",
        },
        currentPage: action.page,
        pageSize: action.pageSize,
        totalCount: action.totalCount,
        searchText: action.searchText || "",
        setSession: action.permaLink || "",
        startDate: action.startDate || null,
        endDate: action.endDate || null,
        loading: false,
      };

    case GET_LELOENTRIES_OPTIMIZED:
      const statusOptimize = action.status || "Active";
      return {
        ...state,
        LeloentriesOptimized: action.payload, // filtered data returned from API
        LeloListStatus: {
          inactive: statusOptimize === "Inactive",
          active: statusOptimize === "Active",
          signed: statusOptimize === "Signed",
        },
        loadingOpt: false,
      };

    case GET_LELOENTRIES_OPTIMIZED_ZIP:
      const statusOptimizezip = action.status || "Active";
      return {
        ...state,
        LeloentriesOptimizedzip: action.payload, // filtered data returned from API
        LeloListStatus: {
          inactive: statusOptimizezip === "Inactive",
          active: statusOptimizezip === "Active",
          signed: statusOptimizezip === "Signed",
        },
        loadingOpt: false,
      };

    case SET_LOADING_OPTIMIZED:
      return {
        ...state,
        loadingOpt: true,
      };

    case "SET_CURRENT_PAGE":
      return {
        ...state,
        currentPage: payload,
      };
    case "SET_IS_SEARCH_ACTIVE":
      return {
        ...state,
        searchText: payload,
      };
    case "SET_SESSION":
      return {
        ...state,
        setSession: payload,
      };
    case "SET_START_DATE":
      return {
        ...state,
        startDate: payload,
      };
    case "SET_END_DATE":
      return {
        ...state,
        endDate: payload,
      }
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case INACTIVE_FILTER:
      return {
        ...state,
        InactiveFiltered: state.SessionEntries.filter(
          (item) => item.status === "Inactive"
        ),
        LeloListStatus: {
          inactive: true,
          active: false,
          signed: false,
        },
        DateFiltered: [], // Clear date filter
      };
    case ON_FORM_DATA_CHANGE:
      return {
        ...state,
        formData: {
          ...state.formData,
          [payload.name]: payload.value,
        },
      };
    case GET_LELOENTRIE:
      return {
        ...state,
        Leloentrie: payload,
      };

    case GET_LELO_SESSION:
      return {
        ...state,
        leloSession: payload,
        loading: false,
        error: null,
      };

    case UPDATE_LELOENTRIE:
      return {
        ...state,
        Leloentries: state.Leloentries.map((Leloentrie) =>
          Leloentrie._id === action.payload._id ? action.payload : Leloentrie
        ),
      };

    case CLEAR_LELOENTRIE:
      return {
        ...state,
        Leloentrie: {},
      };

    case SEARCH_FILTER:
      const escapedPayload = payload.replace(
        /[-[\]{}()*+?.,\\^$|#]/g,  // Removed \s from the regex
        "\\$&"
      );
      const regex = new RegExp(`${escapedPayload}`, "gi");

      // Define which session status should be shown based on the selected session (Active, Inactive, or Signed)
      const selectedSession = state.LeloListStatus.active
        ? "Active"
        : state.LeloListStatus.inactive
          ? "Inactive"
          : state.LeloListStatus.signed
            ? "Signed"
            : null;

      return {
        ...state,
        filteredEntries: state.Leloentries.filter((item) => {
          return (
            (item.createdAt && item.createdAt.match(regex)) ||
            (item.status && item.status.match(regex)) ||
            (item.firstName && item.firstName.match(regex)) ||
            (item.lastName && item.lastName.match(regex)) ||
            (item.studentEmail && item.studentEmail.match(regex)) ||
            (item.studentPrimaryPhone &&
              item.studentPrimaryPhone.match(regex)) ||
            (item.learningCenters && item.learningCenters.match(regex)) ||
            (item._uuid && item._uuid.match(regex))
          );
        }).filter(
          (item) => selectedSession === null || item.status === selectedSession
        ), // Filter by selected session
        SessionEntries: state.SessionEntries.filter((item) => {
          return (
            (item.createdAt && item.createdAt.match(regex)) ||
            (item.status && item.status.match(regex)) ||
            (item.firstName && item.firstName.match(regex)) ||
            (item.lastName && item.lastName.match(regex)) ||
            (item.studentEmail && item.studentEmail.match(regex)) ||
            (item.studentPrimaryPhone &&
              item.studentPrimaryPhone.match(regex)) ||
            (item.learningCenters && item.learningCenters.match(regex)) ||
            (item._uuid && item._uuid.match(regex))
          );
        }).filter(
          (item) => selectedSession === null || item.status === selectedSession
        ), // Filter by selected session
        InactiveFiltered: state.Leloentries.filter((item) => {
          return (
            (item.createdAt && item.createdAt.match(regex)) ||
            (item.status && item.status.match(regex)) ||
            (item.firstName && item.firstName.match(regex)) ||
            (item.lastName && item.lastName.match(regex)) ||
            (item.studentEmail && item.studentEmail.match(regex)) ||
            (item.studentPrimaryPhone &&
              item.studentPrimaryPhone.match(regex)) ||
            (item.learningCenters && item.learningCenters.match(regex)) ||
            (item._uuid && item._uuid.match(regex))
          );
        }).filter((item) => item.status === "Inactive"), // Filter inactive items
        ActiveFiltered: state.Leloentries.filter((item) => {
          return (
            (item.createdAt && item.createdAt.match(regex)) ||
            (item.status && item.status.match(regex)) ||
            (item.firstName && item.firstName.match(regex)) ||
            (item.lastName && item.lastName.match(regex)) ||
            (item.studentEmail && item.studentEmail.match(regex)) ||
            (item.studentPrimaryPhone &&
              item.studentPrimaryPhone.match(regex)) ||
            (item.learningCenters && item.learningCenters.match(regex)) ||
            (item._uuid && item._uuid.match(regex))
          );
        }).filter((item) => item.status === "Active"), // Filter active items
        SignedFiltered: state.Leloentries.filter((item) => {
          return (
            (item.createdAt && item.createdAt.match(regex)) ||
            (item.status && item.status.match(regex)) ||
            (item.firstName && item.firstName.match(regex)) ||
            (item.lastName && item.lastName.match(regex)) ||
            (item.studentEmail && item.studentEmail.match(regex)) ||
            (item.studentPrimaryPhone &&
              item.studentPrimaryPhone.match(regex)) ||
            (item.learningCenters && item.learningCenters.match(regex)) ||
            (item._uuid && item._uuid.match(regex))
          );
        }).filter((item) => item.status === "Signed"), // Filter signed items
      };

    case CLEAR_SEARCH_FILTER:
      return {
        ...state, // Preserve the rest of the state
        SessionEntries: state.Leloentries, // Reset SessionEntries to the full list of Leloentries
        InactiveFiltered: state.Leloentries.filter(
          (item) => item.status === "Inactive"
        ), // Reset InactiveFiltered
        ActiveFiltered: state.Leloentries.filter(
          (item) => item.status === "Active"
        ), // Reset ActiveFiltered
        SignedFiltered: state.Leloentries.filter(
          (item) => item.status === "Signed"
        ), // Reset SignedFiltered
      };

    case FILTER_BY_DATE:
      // Determine which entries to filter based on current status
      let entriesToFilter = state.SessionEntries || state.Leloentries; // Default to all entries

      // Only filter by status if a specific status is selected
      if (state.LeloListStatus.active) {
        entriesToFilter = entriesToFilter.filter(item => item.status === "Active");
      } else if (state.LeloListStatus.inactive) {
        entriesToFilter = entriesToFilter.filter(item => item.status === "Inactive");
      } else if (state.LeloListStatus.signed) {
        entriesToFilter = entriesToFilter.filter(item => item.status === "Signed");
      }

      // Filter by date
      const dateFiltered = entriesToFilter.filter((entry) => {
        const entryDate = new Date(entry.createdAt);
        const startDate = new Date(payload.startDate);
        const endDate = new Date(payload.endDate);
        return entryDate >= startDate && entryDate <= endDate;
      });

      return {
        ...state,
        DateFiltered: dateFiltered,
        SessionEntries: dateFiltered,
        InactiveFiltered: dateFiltered.filter(item => item.status === "Inactive"),
        ActiveFiltered: dateFiltered.filter(item => item.status === "Active"),
        SignedFiltered: dateFiltered.filter(item => item.status === "Signed"),
        loading: false,
      };


    case CLEAR_DATE_FILTER:
      return {
        ...state,
        DateFiltered: null,
        SessionEntries: state.Leloentries,
        InactiveFiltered: state.Leloentries.filter(item => item.status === "Inactive"),
        ActiveFiltered: state.Leloentries.filter(item => item.status === "Active"),
        SignedFiltered: state.Leloentries.filter(item => item.status === "Signed"),
      };


    case FILTER_TABLE:
      const defaultSortOption = { asc: false, desc: false };
      const currentSortOption = state.sortOptions[payload] || defaultSortOption;
      const isAsc = currentSortOption.asc === false;
      const isNormal = currentSortOption.desc === true;

      const sortEntries = (entries) => {
        if (isNormal) {
          return [...entries].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
        }
        if (isAsc) {
          return [...entries].sort((a, b) =>
            a[payload] > b[payload] ? 1 : -1
          );
        }
        return [...entries].sort((a, b) => (a[payload] < b[payload] ? 1 : -1));
      };

      return {
        ...state,
        Leloentries: sortEntries(state.Leloentries),
        SessionEntries: state.SessionEntries.length
          ? sortEntries(state.SessionEntries)
          : [],
        sortOptions: {
          ...state.sortOptions,
          [payload]: isNormal
            ? { asc: false, desc: false }
            : isAsc
              ? { asc: true, desc: false }
              : { asc: false, desc: true },
        },
      };

    case SESSION_FILTER:
      return {
        ...state,
        SessionEntries: state.Leloentries.filter(
          (item) => item.permaLink === payload
        ),
        InactiveFiltered: state.Leloentries.filter(
          (item) => item.status === "Inactive" && item.permaLink === payload
        ),
        ActiveFiltered: state.Leloentries.filter(
          (item) => item.status === "Active" && item.permaLink === payload
        ),
        SignedFiltered: state.Leloentries.filter(
          (item) => item.status === "Signed" && item.permaLink === payload
        ),
      };

    case CLEAR_SESSION_FILTER:
      return {
        ...state,
        SessionEntries: state.Leloentries,
      };

    case ACTIVE_FILTER:
      return {
        ...state,
        ActiveFiltered: state.SessionEntries.filter(
          (item) => item.status === "Active"
        ),
        LeloListStatus: {
          active: true,
          inactive: false,
          signed: false,
        },
        DateFiltered: [], // Clear date filter
      };

    case SIGNED_FILTER:
      return {
        ...state,
        SignedFiltered: state.SessionEntries.filter(
          (item) => item.status === "Signed"
        ),
        LeloListStatus: {
          signed: true,
          inactive: false,
          active: false,
        },
        DateFiltered: [], // Clear date filter
      };

    case CLEAR_INACTIVE_FILTER:
      return {
        ...state,
        InactiveFiltered: [], // Reset inactive filter
        LeloListStatus: {
          ...state.LeloListStatus,
          inactive: false,
        },
      };

    case CLEAR_FILTER_TABLE:
      return {
        ...state,
        sortOptions: {
          createdAt: { asc: false, desc: false },
          status: { asc: false, desc: false },
          firstName: { asc: false, desc: false },
          lastName: { asc: false, desc: false },
          studentEmail: { asc: false, desc: false },
          studentPrimaryPhone: { asc: false, desc: false },
          learningCenters: { asc: false, desc: false },
        },
      };

    case "TOGGLE_COLUMN":
      return {
        ...state,
        visibleColumns: {
          ...state.visibleColumns,
          [payload]: !state.visibleColumns[payload],
        },
      };

    case SET_LIST_VIEW:
      return {
        ...state,
        listView: payload,
      };

    default:
      return state;
  }
};

export default adminLeloReducer;
